import React, { useEffect, useRef, useState } from "react";
import DownloadStyle from "./download.module.css";

import { Button, Collapse, message, Progress, Table, Modal } from "antd";
import lotus_download from "../../assets/json/DownLoad/lotus_download";
import axios from "axios";
import styled from "styled-components";
const Custom = styled(Collapse)`
  .ant-collapse-header {
    background-color: transparent; // 设置折叠面板标题背景色
    color: #000; // 设置标题文字颜色
    font-weight: bold; // 设置标题文字加粗
    &:hover {
      background-color: #d9d9d9; // 设置 hover 状态下的背景色
    }
  }

  .ant-collapse-content {
    background-color: #ffffff; // 设置折叠面板内容区背景色
  }

  .ant-collapse-header-arrow {
    color: #000; // 修改箭头颜色
  }
`;
function DownLoad() {
  const [DownDicots, setDownDicot] = React.useState([]);
  useEffect(() => {}, []);
  const downloadFile = (url, fileName) => {
    message.success("Downloading...");
    axios({
      method: "get",
      url: url,
      responseType: "blob", // 设置响应类型为 'blob'，便于处理文件
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // 设置下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 移除下载链接
        window.URL.revokeObjectURL(url); // 释放内存
        message.success("Download success!");
      })
      .catch((error) => {
        message.error("Download error:", error);
        setTimeout(() => {
          message.destroy();
        }, 3000); // 3000 毫秒后销毁消息
      });
  };
  
  // 使用Map来跟踪多个下载的状态
  const [downloads, setDownloads] = useState(new Map());
  const cancelTokenSources = useRef(new Map());
  const progressTimers = useRef(new Map());
  
  const simulateProgress = (fileName) => {
    // 模拟进度条增长，从0%到80%
    let simulatedProgress = 0;
    const timer = setInterval(() => {
      simulatedProgress += 1;
      
      // Update the download progress
      setDownloads((prev) => {
        const prevDownload = prev.get(fileName);
        if (!prevDownload) return prev; // Download was canceled or completed
        
        // 如果真实进度已经超过了模拟进度或到达了80%，则停止模拟
        if (prevDownload.realProgress > simulatedProgress || simulatedProgress >= 80) {
          clearInterval(timer);
          progressTimers.current.delete(fileName);
          return prev;
        }
        
        const newMap = new Map(prev);
        newMap.set(fileName, {
          ...prevDownload,
          progress: simulatedProgress,
        });
        return newMap;
      });
      
      // 到达80%后停止模拟
      if (simulatedProgress >= 80) {
        clearInterval(timer);
        progressTimers.current.delete(fileName);
      }
    }, 100); // 每100ms增加1%
    
    progressTimers.current.set(fileName, timer);
    return timer;
  };

const DownHttp = (fileName, type) => {
  // 创建新的取消令牌
  const cancelTokenSource = axios.CancelToken.source();
  cancelTokenSources.current.set(fileName, cancelTokenSource);

  // 添加新的下载状态
  setDownloads((prev) =>
    new Map(prev).set(fileName, {
      progress: 0,
      realProgress: 0,
      fileName: fileName,
    })
  );

  // 开始模拟进度
  simulateProgress(fileName);

  message.success(`Downloading ${fileName}...`);

  axios({
    method: "get",
    url: `/api/download/?type=${type}&name=${fileName}`,
    responseType: "blob",
    cancelToken: cancelTokenSource.token,
    onDownloadProgress: (progressEvent) => {
      const realPercentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      
      setDownloads((prev) => {
        const prevDownload = prev.get(fileName);
        if (!prevDownload) return prev; // Download was canceled
        
        const newMap = new Map(prev);
        const finalProgress = realPercentCompleted >= 80 
          ? realPercentCompleted 
          : prevDownload.progress;
          
        newMap.set(fileName, {
          ...prevDownload,
          realProgress: realPercentCompleted,
          progress: finalProgress,
        });
        return newMap;
      });
    },
  })
    .then((response) => {
      // 清除进度模拟定时器
      const timer = progressTimers.current.get(fileName);
      if (timer) {
        clearInterval(timer);
        progressTimers.current.delete(fileName);
      }
      
      // 完成下载，设置进度为100%
      setDownloads((prev) => {
        const newMap = new Map(prev);
        const prevDownload = prev.get(fileName);
        if (prevDownload) {
          newMap.set(fileName, {
            ...prevDownload,
            progress: 100,
            realProgress: 100,
          });
        }
        return newMap;
      });
      
      // 延迟移除进度条，让用户可以看到100%的状态
      setTimeout(() => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        message.success(`${fileName} download success!`);
  
        // 清理下载状态
        setDownloads((prev) => {
          const newMap = new Map(prev);
          newMap.delete(fileName);
          return newMap;
        });
        cancelTokenSources.current.delete(fileName);
      }, 500);
    })
    .catch((error) => {
      // 清除进度模拟定时器
      const timer = progressTimers.current.get(fileName);
      if (timer) {
        clearInterval(timer);
        progressTimers.current.delete(fileName);
      }
      
      if (axios.isCancel(error)) {
        message.info(`${fileName} download canceled`);
      } else {
        console.log(error);
        message.error(`${fileName} download error: ${error.message}`);
        
        // Only clean up state for actual errors, not cancellations
        setDownloads((prev) => {
          const newMap = new Map(prev);
          newMap.delete(fileName);
          return newMap;
        });
        cancelTokenSources.current.delete(fileName);
      }

      setTimeout(() => {
        message.destroy();
      }, 3000);
    });
};

// 取消特定文件的下载
const handleCancelDownload = (fileName) => {
  const source = cancelTokenSources.current.get(fileName);
  if (source) {
    source.cancel();
    cancelTokenSources.current.delete(fileName);
  }
  
  // 清除进度模拟定时器
  const timer = progressTimers.current.get(fileName);
  if (timer) {
    clearInterval(timer);
    progressTimers.current.delete(fileName);
  }
  
  setDownloads((prev) => {
    const newMap = new Map(prev);
    newMap.delete(fileName);
    return newMap;
  });
};

// 确保在组件卸载时清除所有定时器
useEffect(() => {
  return () => {
    // 清除所有进度模拟定时器
    progressTimers.current.forEach((timer) => {
      clearInterval(timer);
    });
    progressTimers.current.clear();
    
    // 取消所有未完成的下载
    cancelTokenSources.current.forEach((source) => {
      source.cancel("Component unmounted");
    });
    cancelTokenSources.current.clear();
  };
}, []);

const [isModalOpen, setIsModalOpen] = useState(false);
const showModal = () => {
  setIsModalOpen(true);
};
const handleOk = () => {
  setIsModalOpen(false);
};
const handleCancel = () => {
  setIsModalOpen(false);
};
  const SetItems = () => {
    let ItemArr = [];

    Object.keys(lotus_download).map((key) => {
      if (key == "Genome") {
        let Colums = [];
        Object.keys(lotus_download[key][0]).map((key2) => {

          Colums.push({
            title: key2,
            dataIndex: key2,
            key: key2,
            align: "center",
            render: (index, item) => {
              if (index != "") {
                if (key2 == 'Genome') {
                  return <p style={{color: "#000"}}>{index}</p>;
                } else {
                  return <p 
                    className={DownloadStyle.Down_p}
                    onClick={() => {
                      // showModal()
                      console.log(index)
                      DownHttp(index,"Genome")
                    }}
                  >{index}</p>;
                }
              }else {
                return <span>-</span>;
              }
            },
          });
        });
        ItemArr.push({
          key: key,
          label: <p style={{ fontSize: "15px", fontWeight: "bold" }}>{key}</p>,
          children: (
            <div className={DownloadStyle.Download_Content}>
              <Table
                columns={Colums}
                dataSource={lotus_download[key]}
                bordered
                pagination={false}
                scroll={{
                  x:1500
                }}
                size="small"
              />
            </div>
          ),
        });
      }
      if (key == "Transcriptome") {
          let Colums2=[]
          Object.keys(lotus_download[key][0]).map((key2)=>{
            Colums2.push({
              title: key2,
              dataIndex: key2,
              key: key2,
              align: "center",
              render: (index, item) => {
                if (index != "") {
                  return <p 
                  className={DownloadStyle.Down_p}
                  onClick={() => {
                    // showModal()
                    DownHttp(index,"Expression")

                  }}
                >{index}</p>;
                } else {
                  return <span>-</span>;
                }
              },
            });
          })
          ItemArr.push({
            key: key,
            label: <p style={{ fontSize: "15px", fontWeight: "bold" }}>{key}</p>,
            children: (
              <div className={DownloadStyle.Download_Content}>
                <Table
                  columns={Colums2}
                  dataSource={lotus_download[key]}
                  bordered
                  pagination={false}
                 
                  size="small"
                />
              </div>
            ),
          });
      }
      // if (key == "Other") {
      //   ItemArr.push({
      //     key: key,
      //     label: <p style={{ fontSize: "15px", fontWeight: "bold" }}>{key}</p>,
      //   });
      // }
    });
    console.log(ItemArr);
    return ItemArr;
  };

  const onChange = (key) => {
    console.log(key);
  };
  return (
    <div className={DownloadStyle.DownLoad_app}>
        {/* 显示所有活动下载的进度条 */}
        <div className={DownloadStyle.downloads_container}>
        {Array.from(downloads.entries()).map(([fileName, downloadInfo]) => (
          <div key={fileName} className={DownloadStyle.download_progress}>
            <div className={DownloadStyle.download_progress_header}>
              <span className={DownloadStyle.download_filename}>{fileName}</span>
            </div>
            <Progress
              percent={downloadInfo.progress}
              status="active"
              strokeColor={{
                "0%": "#108ee9",
                "100%": "#87d068",
              }}
            />
            <Button
              type="primary"
              danger
              onClick={() => handleCancelDownload(fileName)}
              className={DownloadStyle.cancel_button}
            >
              Cancel
            </Button>
          </div>
        ))}
      </div>
      <Modal  title='note' open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <p>Please contact the corresponding author by E-mail</p>
        <p style={{color:"blue"}}>sunheng@wbgcas.cn</p>
        
      </Modal>
      <Custom
        accordion={true}
        bordered={false}
        items={SetItems()}
        onChange={onChange}
        style={{
          border: "none",
          borderRadius: "none",
          width: "90%",
          margin: "10px auto",
        }}
      />

      <div style={{ width: "100%", height: "10vh" }}></div>
    </div>
  );
}

export default DownLoad;
